module.exports = __webpack_public_path__ + "z/aboutme-desktop.d642444f.png";